import React from 'react';

export const AccordionContext = React.createContext({
  visible: false,
  toggleAccordion: null,
  alignIconRight: false,
  useChevronIcon: false
});

export const AccordionProvider = AccordionContext.Provider;
export const AccordionConsumer = AccordionContext.Consumer;
export default AccordionContext;
